
import { Component, Vue } from 'vue-property-decorator'
import { popUpRoute } from '@/services/utils/popupRoute'
import PreviewAvatar from '@/stories/preview-avatar/PreviewAvatar.vue'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import { sellerEndpoints } from '@/modules/seller'
import { ISeller } from '@/modules/seller/types/sellerTypes'

@Component({
  name: 'ResetPassword',
  components: {
    PreviewAvatar,
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class ResetPassword extends Vue {
  loading = false
  isResetBtnLoading = false
  merchantData = { isActive: true } as ISeller
  data = {} as ISeller

  /** submit the data to the desired endpoint. */
  async handleSubmit() {
    const { id } = parsePathQueryString(location.search)
    this.isResetBtnLoading = true
    if (id)
      await sellerEndpoints
        .setPassword(id)
        .then(() => {
          this.isResetBtnLoading = false
          this.closePopUp()
        })
        .finally(() => (this.isResetBtnLoading = false))
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }

  created() {
    this.fetchRemoteData()
  }

  /** call given fetch data function */
  async fetchRemoteData() {
    const { id } = parsePathQueryString(location.search)
    this.loading = true
    if (id)
      try {
        this.merchantData = await sellerEndpoints.get(id)
      } catch (error) {
        throw new Error(`Failed to fetch form data. Due to ${error}`)
      } finally {
        this.loading = false
      }
    else throw new Error('Please, Provide User ID ')
  }
}
